import { useCache, CACHE_KEY } from '@/hooks/web/useCache'
import { TokenType } from '@/api/login/types'
import { decrypt, encrypt } from '@/utils/jsencrypt'

const { wsCache } = useCache()
const { wsCache: sessionCache } = useCache('sessionStorage')

const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'

// 获取token
export const getAccessToken = () => {
  const localAccessToken = wsCache.get(AccessTokenKey)
  if (localAccessToken) {
    return localAccessToken
  }
  const sessionAccessToken = sessionCache.get(AccessTokenKey)
  return sessionAccessToken ? sessionAccessToken : wsCache.get('ACCESS_TOKEN')
}

// 刷新token
export const getRefreshToken = () => {
  return wsCache.get(RefreshTokenKey) || sessionCache.get(RefreshTokenKey)
}

// 设置token
export const setToken = (token: TokenType, rememberMe = true) => {
  if (rememberMe) {
    sessionCache.delete(AccessTokenKey)
    sessionCache.delete(RefreshTokenKey)
    wsCache.set(AccessTokenKey, token.accessToken)
    if (token.refreshToken) {
      wsCache.set(RefreshTokenKey, token.refreshToken)
    } else {
      wsCache.delete(RefreshTokenKey)
    }
    return
  }

  wsCache.delete(AccessTokenKey)
  wsCache.delete(RefreshTokenKey)
  sessionCache.set(AccessTokenKey, token.accessToken)
  if (token.refreshToken) {
    sessionCache.set(RefreshTokenKey, token.refreshToken)
  } else {
    sessionCache.delete(RefreshTokenKey)
  }
}

// 删除token
export const removeToken = () => {
  wsCache.delete(AccessTokenKey)
  wsCache.delete(RefreshTokenKey)
  sessionCache.delete(AccessTokenKey)
  sessionCache.delete(RefreshTokenKey)
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return 'Bearer ' + token
}
// ========== 账号相关 ==========

export type LoginFormType = {
  tenantName?: string
  username: string
  password: string
  rememberMe: boolean
}

export const getLoginForm = () => {
  const loginForm: LoginFormType = wsCache.get(CACHE_KEY.LoginForm)
  if (loginForm) {
    loginForm.password = decrypt(loginForm.password) as string
  }
  return loginForm
}

export const setLoginForm = (loginForm: LoginFormType) => {
  loginForm.password = encrypt(loginForm.password) as string
  wsCache.set(CACHE_KEY.LoginForm, loginForm, { exp: 30 * 24 * 60 * 60 })
}

export const removeLoginForm = () => {
  wsCache.delete(CACHE_KEY.LoginForm)
}

// ========== 租户相关 ==========

export const getTenantId = () => {
  return wsCache.get(CACHE_KEY.TenantId)
}

export const setTenantId = (tenantId: number) => {
  wsCache.set(CACHE_KEY.TenantId, tenantId)
}

export const getVisitTenantId = () => {
  return wsCache.get(CACHE_KEY.VisitTenantId)
}

export const setVisitTenantId = (visitTenantId: number) => {
  wsCache.set(CACHE_KEY.VisitTenantId, visitTenantId)
}
